import { RefObject, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import footerActions from '../../../../actions/footer';

// Prevent footer link overlap with ref elements by setting the footer link container to the height of the ref element
const useAdjustFooterLinks = (ref: RefObject<HTMLDivElement>) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const updateHeight = () => {
      footerActions.setAdjustFooterLinks({ adjustedHeight: element.offsetHeight, isAdjusted: true })(dispatch);
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(element);

    // eslint-disable-next-line consistent-return
    return () => {
      resizeObserver.disconnect();
      footerActions.setAdjustFooterLinks({ isAdjusted: false })(dispatch);
    };
  }, [dispatch, ref]);
};

export default useAdjustFooterLinks;
